<template>
  <div>
    <div
      v-for="(group, index) in conditions"
      :key="'group_' + index"
    >
      <conditions-wrapper
          :total-groups="conditions.length"
          :group-operator="group.operator"
      >
        <template
          v-for="(condition, condIndex) in group.conditions"
        >
          <component
              v-bind:is="condition.type"
              v-if="componentExists(condition.type)"
              :key="'cond_' + index + '_' + condIndex"
              :field="allFields[condition.field] || {}"
              :condition="condition"
          />
          <span
              v-else
              :key="'cond_' + index + '_' + condIndex + '_fallback'"
          >
          <b>{{ criteriaName(condition) }}</b>
          </span>

          <span
              v-if="condIndex < group.conditions.length-1"
              :key="'cond_' + index + '_' + condIndex + 'operator'"
          > {{ group.operator | operator }} </span>
        </template>
      </conditions-wrapper>

      <div
        v-if="index < conditions.length-1"
        :key="'group_' + index + '_operator'"
      ><b>AND</b></div>
    </div>
  </div>
</template>
<script>
import ConditionsWrapper from '@/components/Monitors/ConditionsWrapper';
import Eq from '@/components/Monitors/Conditions/Eq';
import NotEq from '@/components/Monitors/Conditions/NotEq';
import Like from '@/components/Monitors/Conditions/Like';
import IsNull from '@/components/Monitors/Conditions/IsNull';
import Range from '@/components/Monitors/Conditions/Range';
import AdvancedAirwayUsed from '@/components/Monitors/Conditions/AdvancedAirwayUsed';
import BmvUsed from '@/components/Monitors/Conditions/BmvUsed';
import ImageAttached from '@/components/Monitors/Conditions/ImageAttached';
import HasSignature from '@/components/Monitors/Conditions/HasSignature';
import Age from '@/components/Monitors/Conditions/Age';
import Weight from '@/components/Monitors/Conditions/Weight';
import HasBloodTransfusion from '@/components/Monitors/Conditions/HasBloodTransfusion';
import BloodTransfusionSigned from '@/components/Monitors/Conditions/BloodTransfusionSigned';
import PuccFormIsFilled from '@/components/Monitors/Conditions/PuccFormIsFilled';
import SEARCH_CRITERIA from '@/enums/searchCriteria';

export default {
  name: 'ConditionsToText',

  /* eslint-disable vue/no-unused-components */
  components: {
    ConditionsWrapper,
    eq: Eq,
    not_eq: NotEq,
    like: Like,
    is_null: IsNull,
    range: Range,
    advanced_airway_used: AdvancedAirwayUsed,
    bmv_used: BmvUsed,
    image_attached: ImageAttached,
    has_signature: HasSignature,
    age: Age,
    weight: Weight,
    has_blood_transfusion: HasBloodTransfusion,
    blood_transfusion_signed: BloodTransfusionSigned,
    pucc_form_is_filled: PuccFormIsFilled,
  },

  filters: {
    operator(type) {
      const map = {
        and: 'AND',
        not: 'AND',
        or: 'OR',
      };
      return map[type];
    },
  },

  props: {
    conditions: {
      type: Array,
      required: true,
    },
    allFields: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    componentExists(type) {
      return Object.prototype.hasOwnProperty.call(
        this.$options.components,
        type,
      );
    },

    /**
     * Text for a condition that has no component of its own.
     *
     * A criterion known to the search UI is shown by its name, so an existing monitor
     * built on it reads sensibly. A type missing from SEARCH_CRITERIA is new to the
     * frontend and stays loud, otherwise such a gap would never be noticed.
     */
    criteriaName(condition) {
      const name = SEARCH_CRITERIA[condition.type];
      if (!name) {
        // eslint-disable-next-line no-console
        console.warn(`ConditionsToText: unknown condition type "${condition.type}"`);

        return `"${condition.type}" is not implemented yet`;
      }
      // eslint-disable-next-line no-console
      console.warn(`ConditionsToText: no component for condition type "${condition.type}"`);
      const field = this.allFields[condition.field];

      return field && field.name ? `${field.name}: ${name}` : name;
    },
  },
};
</script>
